package one.healthium.log_food.ui.camera

data class CameraUiState(
    val isLoading: Boolean = false,
    val frozenPhotoBytes: StableByteArray? = null,
    val frozenPhotoPath: String? = null,
)
